const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmt = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const rowsHtml = rows
    .map(
      (row, index) => `
      <tr>
        <td class="text-center">${index + 1}</td>
        <td class="text-center">${escapeHtml(row.contributionMonth)}</td>
        <td class="text-right">${fmt(row.totalSalaryFund)}</td>
        <td class="text-right">${fmt(row.insuranceTotal)}</td>
        <td class="text-right">${fmt(row.contributionToExpense)}</td>
        <td class="text-right">${fmt(row.deductionFromSalary)}</td>
        <td class="text-right">${fmt(row.unionFundTotal)}</td>
        <td class="text-right">${fmt(row.unionFundPayable)}</td>
        <td class="text-right">${fmt(row.unionFundRetained)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Bảng Kê Trích Nộp Các Khoản Theo Lương</title>
      <style>
        @media print { @page { margin: 10mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 13px; color: #000; padding: 16px; }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid #000; padding: 3px 4px; }
        th { text-align: center; font-weight: 700; vertical-align: middle; }
        .text-left { text-align: left; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .header-row { display: flex; justify-content: space-between; margin-bottom: 8px; }
        .title { text-align: center; font-size: 24px; font-weight: 700; text-transform: uppercase; margin: 8px 0 4px; white-space: nowrap; }
        .sub { text-align: center; margin-bottom: 8px; }
        .signatures { display: flex; justify-content: space-between; margin-top: 34px; text-align: center; align-items: flex-start; }
        .sign-box { width: 32%; position: relative; }
        .sign-date { position: absolute; top: -18px; left: 0; width: 100%; text-align: center; }
        .italic { font-style: italic; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header-row">
        <div>
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit)}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department)}</div>
        </div>
        <div class="text-center">
          <div><b>Mẫu số: 07 - LĐTL</b></div>
          <div class="italic">(Kèm theo Thông tư số 99/2025/TT-BTC</div>
          <div class="italic">ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      <div class="title">Bảng kê trích nộp các khoản theo lương</div>
      <div class="sub">Tháng ${escapeHtml(headerInfo.month)} năm ${escapeHtml(headerInfo.year)}</div>

      <div style="display:flex;justify-content:flex-end;gap:24px;margin-bottom:8px;">
        <div>Số: ${escapeHtml(headerInfo.documentNumber)}</div>
        <div>Đơn vị tính: ${escapeHtml(headerInfo.currencyUnit)}</div>
      </div>

      <table>
        <thead>
          <tr>
            <th rowspan="3">STT</th>
            <th rowspan="3">Số tháng trích BHXH, BHYT, BHTN, KPCĐ</th>
            <th rowspan="3">Tổng quỹ lương trích BHXH, BHYT, BHTN, KPCĐ</th>
            <th colspan="3">BHXH, BHYT, BHTN</th>
            <th colspan="3">KPCĐ</th>
          </tr>
          <tr>
            <th rowspan="2">Tổng số</th>
            <th colspan="2">Trong đó:</th>
            <th rowspan="2">Tổng số</th>
            <th rowspan="2">Số phải nộp công đoàn cấp trên</th>
            <th rowspan="2">Số được để lại chi đơn vị</th>
          </tr>
          <tr>
            <th>Trích vào chi phí</th>
            <th>Trừ vào lương</th>
          </tr>
          <tr>
            <th>A</th>
            <th>B</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td></td>
            <td class="text-center"><b>Cộng</b></td>
            <td class="text-right"><b>${fmt(totals.totalSalaryFund)}</b></td>
            <td class="text-right"><b>${fmt(totals.insuranceTotal)}</b></td>
            <td class="text-right"><b>${fmt(totals.contributionToExpense)}</b></td>
            <td class="text-right"><b>${fmt(totals.deductionFromSalary)}</b></td>
            <td class="text-right"><b>${fmt(totals.unionFundTotal)}</b></td>
            <td class="text-right"><b>${fmt(totals.unionFundPayable)}</b></td>
            <td class="text-right"><b>${fmt(totals.unionFundRetained)}</b></td>
          </tr>
        </tbody>
      </table>

      <div class="signatures">
        <div class="sign-box">
          <b>Người lập bảng</b><br />
          <span class="italic">(Ký, họ tên)</span>
        </div>
        <div class="sign-box">
          <b>Kế toán trưởng</b><br />
          <span class="italic">(Ký, họ tên)</span>
        </div>
        <div class="sign-box">
          <div class="sign-date italic">Ngày....tháng....năm....</div>
          <b>Giám đốc</b><br />
          <span class="italic">(Ký, họ tên)</span>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
